import MarkdownPage from "../components/MarkdownPage";

export default function PrivacyPolicy() {
  return (
    <MarkdownPage
      title="Privacy Policy"
      file="/legal/privacy-policy.md"
    />
  );
}
